import { __extends } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import PrinterService from '@/modules/printers/PrinterService';
var printer = {
  name: '',
  category: [],
  main_tpv: '',
  secondary_tpv: [],
  zone: [],
  allow_to_march: false,
  family: [],
  printer_width: '0'
};

var PrinterModel =
/** @class */
function (_super) {
  __extends(PrinterModel, _super);

  function PrinterModel() {
    var _this = _super.call(this, printer, PrinterService) || this;

    _this.modelName = 'Impresora';
    _this.request = 'JSON';
    return _this;
  }

  return PrinterModel;
}(BaseModel);

export default PrinterModel;